export default __webpack_public_path__ + "static/media/settings-icon.59872ef6.svg";